import Axios from '@/utils/axios';

// ─── Integration API access ───────────────────────────────────────────
//   GET /v1/integration/sandbox-availability
// Which integration APIs the signed-in client may use — the backend's
// INTEGRATION_API_ACCESS, the same config that rejects the API calls
// themselves. Covers live and sandbox alike. Read once per client per app
// load (IntegrationAccessContext).
export interface SandboxAvailability {
  /** Shipments: docs, sandbox shipments, webhooks. */
  shipmentSandbox: boolean;
  /** WMS: outbound order docs + sandbox orders, and the Warehouse menu. */
  wmsSandbox: boolean;
}

export const getSandboxAvailability =
  async (): Promise<SandboxAvailability> => {
    const res = await Axios.get<{ status: string; data: SandboxAvailability }>(
      '/v1/integration/sandbox-availability',
      { headers: { 'X-Channel': 'LINK', 'X-Api-Mode': 'live' } }
    );
    return res.data.data;
  };
